import { Facebook, Instagram, Linkedin } from "lucide-react";
import { useLang } from "@/i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-[#A87C4F]/25 bg-[#ECE7DE]">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
        <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
          <div>
            <img
              src="/assets/ebs-logo-gold.png"
              alt="EBS Hotels Revenue — Maximize your hotel's revenue"
              data-testid="footer-logo-image"
              className="h-24 w-auto object-contain"
            />
            <p className="mt-5 max-w-md text-sm leading-relaxed text-[#948678]">
              {t.footer.tagline}
            </p>
          </div>

          <div className="flex flex-col gap-4">
            <a
              href="https://www.facebook.com/ebshotelsrevenue"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook-link"
              className="inline-flex items-center gap-3 rounded-sm border border-[#A87C4F]/40 bg-white/50 px-5 py-3 text-sm text-[#5F5647] transition-colors duration-300 hover:border-[#A87C4F]/70 hover:text-[#856237]"
            >
              <Facebook size={17} />
              {t.footer.facebook}
            </a>
            <a
              href="https://www.instagram.com/valeriadragneva.consulting"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="inline-flex items-center gap-3 rounded-sm border border-[#A87C4F]/40 bg-white/50 px-5 py-3 text-sm text-[#5F5647] transition-colors duration-300 hover:border-[#A87C4F]/70 hover:text-[#856237]"
            >
              <Instagram size={17} />
              @valeriadragneva.consulting
            </a>
            <a
              href="https://www.linkedin.com/in/valeriadragneva"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin-link"
              className="inline-flex items-center gap-3 rounded-sm border border-[#A87C4F]/40 bg-white/50 px-5 py-3 text-sm text-[#5F5647] transition-colors duration-300 hover:border-[#A87C4F]/70 hover:text-[#856237]"
            >
              <Linkedin size={17} />
              Valeria Dragneva sur LinkedIn
            </a>
            <p className="text-[11px] uppercase tracking-[0.2em] text-[#948678]">
              {t.footer.location}
            </p>
          </div>
        </div>

        <div className="gold-hairline mt-12" />

        <div className="mt-7 flex flex-col items-start justify-between gap-3 text-[11px] tracking-wide text-[#948678] sm:flex-row sm:items-center">
          <p>{t.footer.copyright}</p>
          <a
            href="/mentions-legales"
            data-testid="footer-legal-link"
            className="underline-offset-4 transition-colors hover:text-[#856237] hover:underline"
          >
            Mentions Légales & CGV
          </a>
          <p>{t.footer.ethics}</p>
        </div>
      </div>
    </footer>
  );
}
